import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

export type VacancyOnlineUsersCounters = Record<number, { includingCurrent: number; excludingCurrent: number }>;

const vacancyOnlineUsersCounters = autoGeneratedReducer<VacancyOnlineUsersCounters>(null);
export { vacancyOnlineUsersCounters };
